/* eslint-disable react/no-unused-state */
import { DSIndeterminateProgressIndicator } from '@elliemae/ds-indeterminate-progress-indicator';
import { LoaderBox } from './styled.js';

interface Props {
  isOpen: boolean;
}

export const Loader = ({ isOpen }: Props) => (
  <LoaderBox className={isOpen ? 'opened' : ''}>
    <DSIndeterminateProgressIndicator processing title="Loading" />
  </LoaderBox>
);
